// 📂 components/shared/MessagePopup.jsx
import React from "react";

export const MessagePopup = ({ message, type, onClose }) => {
    const popupStyle = {
        padding: "15px",
        borderRadius: "10px",
        backgroundColor: type === "success" ? "#d4edda" : type === "error" ? "#f8d7da" : "#fff3cd",
        color: type === "success" ? "#155724" : type === "error" ? "#721c24" : "#856404",
        border: type === "success" ? "1px solid #c3e6cb" : type === "error" ? "1px solid #f5c6cb" : "1px solid #ffeeba",
        position: "fixed",
        top: "10%",
        right: "20px",
        zIndex: 1000,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        minWidth: "300px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    };

    return (
        <div style={popupStyle}>
            <span>{message}</span>
            <button onClick={onClose} style={{ border: "none", background: "transparent", cursor: "pointer" }}>
                ❌
            </button>
        </div>
    );
};

